import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FrequencyTranslatePipe } from './frequency-pipe.pipe';



@NgModule({
  declarations: [
    FrequencyTranslatePipe
  ],
  imports: [
    CommonModule
  ],
  exports: [
    FrequencyTranslatePipe
  ],
})
export class FrequencyPipeModule { }
